'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

var _dateFunctions = require('../../helpers/dateFunctions');

var _dateFunctions2 = _interopRequireDefault(_dateFunctions);

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getApplicantAgeOnEffDate(applicant, effective_date) {
  return _moment2.default.duration((0, _moment2.default)(effective_date).diff((0, _moment2.default)(applicant.dob))).as('years');
}

function applicantNeedsMQ(applicant, effective_date) {
  var applicantAgeOnEffDate = getApplicantAgeOnEffDate(applicant, effective_date);
  return applicantAgeOnEffDate >= 75 && applicantAgeOnEffDate < 85 && applicant.additional_data.pe_coverage === 'yes';
}

function areTooManyMQRequired(applicants, effective_date) {
  var numOfMqRequired = 0;
  applicants.forEach(function (applicant, index) {
    if (applicantNeedsMQ(applicant, effective_date)) {
      numOfMqRequired++;
    }
  });
  return numOfMqRequired > 2;
}

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */

exports.default = function (values, props) {
  return {
    applicant: values.applicant.map(function (applicantItem, i) {
      return {
        dob: !applicantItem.dob,
        first_name: !applicantItem.first_name,
        last_name: !applicantItem.last_name,
        email: i === 0 && !applicantItem.email,
        additional_data: _extends({
          relationship_to_primary_applicant: i > 0 && !applicantItem.additional_data.relationship_to_primary_applicant
        }, !props.hideMQ && {
          mq: {
            mq1: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq1 || applicantItem.additional_data.mq.mq1 === '1'),
            mq2: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq2 || applicantItem.additional_data.mq.mq2 === '1'),
            mq3: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq3 || applicantItem.additional_data.mq.mq3 === '1'),
            mq4: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq4 || applicantItem.additional_data.mq.mq4 === '1'),
            mq5: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq5 || applicantItem.additional_data.mq.mq5 === '1'),
            mq6: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq6 || applicantItem.additional_data.mq.mq6 === '1'),
            mq7: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq7 || applicantItem.additional_data.mq.mq7 === '1'),
            mq8: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq8 || applicantItem.additional_data.mq.mq8 === '1'),
            mq9: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq9 || applicantItem.additional_data.mq.mq9 === '1'),
            mq10: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq10 || applicantItem.additional_data.mq.mq10 === '1'),
            mq11: applicantNeedsMQ(applicantItem, values.application.effective_date) && (!applicantItem.additional_data.mq.mq11 || applicantItem.additional_data.mq.mq11 === '1')
          }
        })
      };
    }),
    application: {
      effective_date: !values.application.effective_date,
      expiry_date: values.application.additional_data.super_visa === 'no' && !values.application.expiry_date,
      additional_data: {
        country_of_origin: !values.application.additional_data.country_of_origin,
        in_canada: !values.application.additional_data.in_canada,
        super_visa: !values.application.additional_data.super_visa,
        coverage: !values.application.additional_data.coverage,
        eligibility: !values.application.additional_data.eligibility,
        deductible: !values.application.additional_data.deductible
      }
    },
    payment: values.application.additional_data.super_visa === 'no' && values.application.additional_data.coverage >= 100000 && (0, _moment2.default)(values.application.expiry_date).diff((0, _moment2.default)(values.application.effective_date), 'days') === 364 + _dateFunctions2.default.getLeapYearDay(values.application.effective_date, 364) && !values.payment.payment_option,
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/rimi_vtc/Quote.js
// module id = 1779
// module chunks = 0